import React from 'react';

import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    platform: [
      { label: "How It Works", path: "#how-it-works" },
      { label: "Support Options", path: "#support-options" },
      { label: "Crisis Resources", path: "#crisis-resources" },
      { label: "Privacy & Security", path: "#privacy" }
    ],
    resources: [
      { label: "Mental Health Resources", path: "#resources" },
      { label: "Helper Guidelines", path: "#helper-guidelines" },
      { label: "FAQs", path: "#faqs" },
      { label: "Contact Support", path: "mailto:support@cwtch.com" }
    ],
    legal: [
      { label: "Privacy Policy", path: "#privacy" },
      { label: "Terms of Service", path: "#terms" },
      { label: "HIPAA Notice", path: "#hipaa" },
      { label: "Accessibility", path: "#accessibility" }
    ]
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/assets/images/CWTCH-1764836850908.png" 
                alt="Cwtch logo - pursuing happiness" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Connecting people with mental health support through lived experience and professional care.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://twitter.com/cwtch"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-muted hover:bg-primary/10 flex items-center justify-center transition-colors duration-200"
              >
                <Icon name="Twitter" size={18} className="text-foreground" />
              </a>
              <a
                href="https://linkedin.com/company/cwtch"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-muted hover:bg-primary/10 flex items-center justify-center transition-colors duration-200"
              >
                <Icon name="Linkedin" size={18} className="text-foreground" />
              </a>
              <a
                href="mailto:support@cwtch.com"
                className="w-9 h-9 rounded-lg bg-muted hover:bg-primary/10 flex items-center justify-center transition-colors duration-200"
              >
                <Icon name="Mail" size={18} className="text-foreground" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Platform</h3>
            <ul className="space-y-3">
              {footerLinks?.platform?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link, index) => (
                <li key={index}>
                  {link?.path?.startsWith('mailto:') ? (
                    <a
                      href={link?.path}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                    >
                      {link?.label}
                    </a>
                  ) : (
                    <a
                      href={link?.path}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                    >
                      {link?.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {currentYear} Cwtch Platform. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-muted-foreground">Powered by secure enterprise infrastructure</span>
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} className="text-success" />
                <span className="text-xs font-medium text-success">ISO 27001 Certified</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;